var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCrown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.55 10.7356H2.45C2.2575 10.7356 2.1 10.9022 2.1 11.1058V11.476C2.1 11.6796 2.2575 11.8462 2.45 11.8462H11.55C11.7425 11.8462 11.9 11.6796 11.9 11.476V11.1058C11.9 10.9022 11.7425 10.7356 11.55 10.7356ZM12.95 2.96154C12.3703 2.96154 11.9 3.45898 11.9 4.07212C11.9 4.23639 11.935 4.38909 11.9963 4.53023L10.4125 5.53438C10.2987 5.6061 10.1762 5.64081 10.0538 5.64081C9.81094 5.64081 9.57469 5.50661 9.44562 5.2683L7.66281 1.96665C7.89687 1.76304 8.05 1.45763 8.05 1.11058C8.05 0.497446 7.57969 0 7 0C6.42031 0 5.95 0.497446 5.95 1.11058C5.95 1.45763 6.10313 1.76304 6.33719 1.96665L4.55437 5.26599C4.42531 5.50661 4.18906 5.63849 3.94625 5.63849C3.82375 5.63849 3.69906 5.60379 3.5875 5.53206L2.00594 4.52791C2.065 4.38909 2.10219 4.23407 2.10219 4.0698C2.10219 3.45667 1.63187 2.95922 1.05219 2.95922C0.4725 2.95922 0 3.45898 0 4.07212C0 4.68525 0.470313 5.18269 1.05 5.18269C1.10687 5.18269 1.16375 5.17344 1.21844 5.16418L2.8 9.625H11.2L12.7816 5.16418C12.8362 5.17344 12.8931 5.18269 12.95 5.18269C13.5297 5.18269 14 4.68525 14 4.07212C14 3.45898 13.5297 2.96154 12.95 2.96154ZM10.4716 8.51442H3.52844L2.74094 6.29096L3.04719 6.48531C3.31844 6.65883 3.63125 6.74907 3.94625 6.74907C4.57406 6.74907 5.15594 6.39276 5.46656 5.81665L7 2.97773L8.53344 5.81665C8.84406 6.39276 9.42594 6.74907 10.0538 6.74907C10.3709 6.74907 10.6816 6.65883 10.9528 6.48531L11.2591 6.29096L10.4716 8.51442Z",
    fill: "inherit"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCrown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crown.572261a0cd16e72a083cef94a956266e.svg";